{
  "auth": {
    "onboarding": {
      "foreign": {
        "prompt": "أدخل بياناتك الطبية.",
        "fullName": "الاسم الكامل",
        "specialty": "التخصص",
        "specialtyPlaceholder": "مثلاً أمراض القلب",
        "specialtyChoose": "اختر تخصصك",
        "specialtyGroupSpecialty": "التخصصات",
        "specialtyGroupSubspecialty": "التخصصات الدقيقة",
        "specialtyOther": "أخرى (غير موجود في القائمة)",
        "specialtyOtherLabel": "تخصصك",
        "specialtyUnknown": "هذا التخصص غير موجود في القائمة. يرجى الاختيار مرة أخرى.",
        "degree": "الشهادة",
        "degreePlaceholder": "مثلاً MD أو MBChB",
        "country": "البلد الذي أصدر الترخيص",
        "countryPlaceholder": "اختر البلد",
        "city": "المدينة",
        "license": "رقم الترخيص الطبي (اختياري)",
        "licenseHint": "الرقم الصادر عن بلدك.",
        "notice": "تُحفظ هذه البيانات دون تحقق، وسيظهر ملفك الشخصي بعلامة «غير موثّق».",
        "incomplete": "أدخل الاسم والتخصص والشهادة والبلد والمدينة.",
        "licenseTaken": "رقم الترخيص هذا مسجّل مسبقاً لحساب آخر.",
        "notAllowed": "هذا المسار مخصّص للأرقام من خارج إيران فقط. يرجى إدخال رقم النظام الطبي.",
        "unverified": "غير موثّق"
      }
    }
  }
}
